import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FiMessageCircle } from 'react-icons/fi';
import { API_URL } from '../../Api/api';
import { getAuthToken } from '../../Api/authToken';

const ChatNotify = ({ basePath = '/admin', notificationsUrl = '' }) => {
  const navigate = useNavigate();
  const wrapRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [unread, setUnread] = useState(0);
  const [items, setItems] = useState([]);

  const load = async () => {
    try {
      const res = await axios.get(notificationsUrl || `${API_URL}/admin/chat/notifications`, {
        headers: { Authorization: `Bearer ${getAuthToken()}` },
      });
      setUnread(Number(res.data?.unread) || 0);
      setItems(Array.isArray(res.data?.items) ? res.data.items : []);
    } catch {
      /* header badge can retry on the next poll */
    }
  };

  useEffect(() => {
    load();
    const timer = setInterval(load, 8000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const onDown = (event) => {
      if (wrapRef.current && !wrapRef.current.contains(event.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDown);
    return () => document.removeEventListener('mousedown', onDown);
  }, []);

  const openThread = (id) => {
    setOpen(false);
    const item = items.find((row) => row.id === id);
    if (item?.user_id) navigate(`${basePath}/chat?user=${item.user_id}`);
    else navigate(`${basePath}/unknown-user?thread=${id}`);
  };

  return (
    <div className="chat-notify" ref={wrapRef}>
      <button
        type="button"
        className="header-icon-btn"
        aria-label="Chat notifications"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        <FiMessageCircle />
        {unread > 0 && <span className="chat-notify__badge">{unread > 9 ? '9+' : unread}</span>}
      </button>
      {open && (
        <div className="chat-notify__panel" role="dialog" aria-label="Chat notifications">
          <p className="chat-notify__title">Chat</p>
          {items.length === 0 && <p className="chat-notify__empty">No new chat messages.</p>}
          {items.map((item) => (
            <button type="button" key={item.id} className="chat-notify__item" onClick={() => openThread(item.id)}>
              <strong>{item.name}</strong>
              <span>{item.preview}</span>
            </button>
          ))}
          <button type="button" className="chat-notify__all" onClick={() => { setOpen(false); navigate(`${basePath}/chat`); }}>
            Open inbox
          </button>
        </div>
      )}
    </div>
  );
};

export default ChatNotify;
